// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const SelectedSpaLevels = t.list(KeyValuePair, 'SelectedSpaLevels');

export const getDefaultState = () => new SelectedSpaLevels([]);

export default SelectedSpaLevels;



// WEBPACK FOOTER //
// ./src/tabm/wip/state/selected-spa-levels.js